export default __webpack_public_path__ + "static/media/charm-2.4978a59a.png";